import React, { Component, createRef } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './RedemptionModelInformation.scss';
import { Input } from 'reactstrap';
import { setRedemptionModelInformation } from '../../actions';

import {
  Tooltip,
  Dropdown,
  HeaderSection,
  Card,
  validateNumber,
} from '../../helpers';

class RedemptionModelInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'maximumRedemptionMinutesCar':'',
      'maximumRedemptionQuotaCar':'',
      'redemptionModelCar': '',
      'maximumRedemptionMinutesMotorcycle':'',
      'maximumRedemptionQuotaMotorcycle':'',
      'redemptionModelMotorcycle': '',
    };
    this.carRedemptionModel = createRef();
    this.motorcycleRedemptionModel = createRef();
  }

  componentDidMount() {
    this.dataFillInput();
  }

  dataFillInput(){
    const { redemptionModelInformation } = this.props;

    if (redemptionModelInformation){
      this.setState({
        'maximumRedemptionMinutesCar': redemptionModelInformation.maximumRedemptionMinutesCar.toString(), 
        'maximumRedemptionQuotaCar': redemptionModelInformation.maximumRedemptionQuotaCar.toString(),
        'maximumRedemptionMinutesMotorcycle': redemptionModelInformation.maximumRedemptionMinutesMotorcycle.toString(),
        'maximumRedemptionQuotaMotorcycle': redemptionModelInformation.maximumRedemptionQuotaMotorcycle.toString(), 
        'redemptionModelCar': redemptionModelInformation.redemptionModelCar,
        'redemptionModelMotorcycle': redemptionModelInformation.redemptionModelMotorcycle,
      }, () => {this.props.dispatch(setRedemptionModelInformation({
        ...redemptionModelInformation,
        'isCanSave' : this.handelCheckCanSave(),
      }));});
    }
  }

  handelCheckCanSave = () => {
    const { maximumRedemptionMinutesCar, maximumRedemptionQuotaCar, maximumRedemptionMinutesMotorcycle, maximumRedemptionQuotaMotorcycle, redemptionModelCar, redemptionModelMotorcycle } = this.state;
    if (maximumRedemptionMinutesCar !== '' && maximumRedemptionQuotaCar !== '' && maximumRedemptionMinutesMotorcycle !== '' && maximumRedemptionQuotaMotorcycle !== '' && redemptionModelCar !== '' && redemptionModelMotorcycle !== '') {
      return true;
    } else {
      return false;
    }
  }

  handleIsCanSave = () => {
    const { maximumRedemptionMinutesCar, maximumRedemptionQuotaCar, maximumRedemptionMinutesMotorcycle, maximumRedemptionQuotaMotorcycle, redemptionModelCar, redemptionModelMotorcycle } = this.state;
    if (this.handelCheckCanSave()){ 
      this.props.dispatch(setRedemptionModelInformation({ 
        'maximumRedemptionMinutesCar' : maximumRedemptionMinutesCar != '' ? parseInt(maximumRedemptionMinutesCar) : 0,
        'maximumRedemptionQuotaCar' : maximumRedemptionQuotaCar != '' ? parseInt(maximumRedemptionQuotaCar) : 0,
        'maximumRedemptionMinutesMotorcycle' : maximumRedemptionMinutesMotorcycle != '' ? parseInt(maximumRedemptionMinutesMotorcycle) : 0 ,
        'maximumRedemptionQuotaMotorcycle' : maximumRedemptionQuotaMotorcycle != '' ? parseInt(maximumRedemptionQuotaMotorcycle) : 0,
        'redemptionModelCar' : redemptionModelCar,
        'redemptionModelMotorcycle' : redemptionModelMotorcycle,
        'isCanSave' : true,
      }));
    } else {
      this.props.dispatch(setRedemptionModelInformation({ 
        'maximumRedemptionMinutesCar' : maximumRedemptionMinutesCar != '' ? parseInt(maximumRedemptionMinutesCar) : 0,
        'maximumRedemptionQuotaCar' : maximumRedemptionQuotaCar != '' ? parseInt(maximumRedemptionQuotaCar) : 0,
        'maximumRedemptionMinutesMotorcycle' : maximumRedemptionMinutesMotorcycle != '' ? parseInt(maximumRedemptionMinutesMotorcycle) : 0 ,
        'maximumRedemptionQuotaMotorcycle' : maximumRedemptionQuotaMotorcycle != '' ? parseInt(maximumRedemptionQuotaMotorcycle) : 0,
        'redemptionModelCar' : redemptionModelCar,
        'redemptionModelMotorcycle' : redemptionModelMotorcycle,
        'isCanSave' : false,
      }));
    }
  }

    handleEvent = (key, value) => {
      this.setState({ [key]: value },() => {this.handleIsCanSave();});
    }

    handleEventDropdown = (event, key) => {
      this.setState({ [key]: event }, () => {this.handleIsCanSave();});    

      if (key === 'redemptionModelCar') {
        this.carRedemptionModel.current.handleShowItem();
      } else if (key === 'redemptionModelMotorcycle') {
        this.motorcycleRedemptionModel.current.handleShowItem();
      }
    }

    redemptionModelCar = () => {
      const { maximumRedemptionMinutesCar, maximumRedemptionQuotaCar , redemptionModelCar } = this.state;

      return (
        <>
          <div className="gray-background">
            <Card>
              <HeaderSection title="Redemption model car" isHeader={true} isBlack={true}/>
              <div className="row-items box-content">
                <div className="box-item">
                  <div className="width-input">
                    <div className="title-input">
                      <Tooltip tooltip="รูปแบบสิทธิการรับส่วนลด">
                        Redemption model
                      </Tooltip>
                    </div>
                    <Dropdown template="b" placeholder="Choose Redemption model" value={redemptionModelCar} ref={this.carRedemptionModel} >
                      <div className={'item'} onClick={() => this.handleEventDropdown('TOP_UP', 'redemptionModelCar')}>
                    Top up
                      </div>
                      <div className={'item'} onClick={() => this.handleEventDropdown('MAXIMUM_RATE', 'redemptionModelCar')}>
                    Maximum Rate
                      </div>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="row-items ">
                <div className="box-item">
                  <div className="width-input">
                    <div className="title-input">
                      <Tooltip tooltip="กำหนดสิทธิการรับส่วนลดค่าบริการสูงสุดในรูปแบบเวลา (นาที)">
                        Maximum redemption minutes
                      </Tooltip>
                    </div>
                    <Input
                      id="building-contact-name"
                      className={'template-d'}
                      placeholder="Input maximum redemption minutes"
                      value={maximumRedemptionMinutesCar}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (validateNumber(value)) {
                          this.handleEvent('maximumRedemptionMinutesCar', value);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row-items ">
                <div className="box-item">
                  <div className="width-input">
                    <div className="title-input">
                      <Tooltip tooltip="กำหนดสิทธิการรับส่วนลดค่าบริการสูงสุดในรูปแบบจำนวนครั้ง">
                        Maximum redemption quota
                      </Tooltip>
                    </div>
                    <Input
                      id="building-contact-name"
                      className={'template-d'}
                      placeholder="Input maximum redemption quota"
                      value={maximumRedemptionQuotaCar}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (validateNumber(value)) {
                          this.handleEvent('maximumRedemptionQuotaCar', value);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </>
      );
    } 

    redemptionModelMotorcycle = () => {
      const { maximumRedemptionMinutesMotorcycle, maximumRedemptionQuotaMotorcycle , redemptionModelMotorcycle } = this.state;

      return (
        <>
          <div className="gray-background">
            <Card>
              <HeaderSection title="Redemption model motorcycle" isHeader={true} isBlack={true}/>
              <div className="row-items box-content">
                <div className="box-item">
                  <div className="width-input">
                    <div className="title-input">
                      <Tooltip tooltip="รูปแบบสิทธิการรับส่วนลด">
                        Redemption model
                      </Tooltip>
                    </div>
                    <Dropdown template="b" placeholder="Choose Redemption model" value={redemptionModelMotorcycle} ref={this.motorcycleRedemptionModel} >
                      <div className={'item'} onClick={() => this.handleEventDropdown('TOP_UP', 'redemptionModelMotorcycle')}>
                    Top up
                      </div>
                      <div className={'item'} onClick={() => this.handleEventDropdown('MAXIMUM_RATE', 'redemptionModelMotorcycle')}>
                    Maximum Rate
                      </div>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="row-items ">
                <div className="box-item">
                  <div className="width-input">
                    <div className="title-input">
                      <Tooltip tooltip="กำหนดสิทธิการรับส่วนลดค่าบริการสูงสุดในรูปแบบเวลา (นาที)">
                        Maximum redemption minutes
                      </Tooltip>
                    </div>
                    <Input
                      id="building-contact-name"
                      className={'template-d'}
                      placeholder="Input maximum redemption minutes"
                      value={maximumRedemptionMinutesMotorcycle}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (validateNumber(value)) {
                          this.handleEvent('maximumRedemptionMinutesMotorcycle', value);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row-items ">
                <div className="box-item">
                  <div className="width-input">
                    <div className="title-input">
                      <Tooltip tooltip="กำหนดสิทธิการรับส่วนลดค่าบริการสูงสุดในรูปแบบจำนวนครั้ง">
                        Maximum redemption quota
                      </Tooltip>
                    </div>
                    <Input
                      id="building-contact-name"
                      className={'template-d'}
                      placeholder="Input maximum redemption quota"
                      value={maximumRedemptionQuotaMotorcycle}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (validateNumber(value)) {
                          this.handleEvent('maximumRedemptionQuotaMotorcycle', value);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </>
      );
    } 

    render() {
      return (
        <div className="RedemptionModelInformation">
          <HeaderSection title="Redemption model" isHeader={true} />
          <div className="screen-box">
            <div className="two-side-box">
              {this.redemptionModelCar()}
              {this.redemptionModelMotorcycle()}
            </div>
          </div>
        </div>
      );
    }
}

RedemptionModelInformation.propTypes = {
  'dispatch' : PropTypes.func,
  'redemptionModelInformation': PropTypes.shape({
    'maximumRedemptionMinutesCar' : PropTypes.number,
    'maximumRedemptionQuotaCar' : PropTypes.number,
    'maximumRedemptionMinutesMotorcycle' : PropTypes.number,
    'maximumRedemptionQuotaMotorcycle' : PropTypes.number,
    'redemptionModelCar' : PropTypes.string,
    'redemptionModelMotorcycle' : PropTypes.string,
  }),
};
  
const mapStateToProps = ({ redemptionModelInformation }) => ({
  'redemptionModelInformation': redemptionModelInformation.data,
});
  
export default connect(mapStateToProps)(RedemptionModelInformation);

